import { render } from "./PublicLayout.vue?vue&type=template&id=2d5fd25b&scoped=true"
import script from "./PublicLayout.vue?vue&type=script&lang=js"
export * from "./PublicLayout.vue?vue&type=script&lang=js"

import "./PublicLayout.vue?vue&type=style&index=0&id=2d5fd25b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5fd25b"]])

export default __exports__